// extracted by mini-css-extract-plugin
export default {"button":"loadingButton_button__sA3BO","rotating":"loadingButton_rotating__+kxQc"};